import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';
import checkFaders from './animations.js';

export default (id) => ({
  init() {
    if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
      // Reload page on resize (debounced)
      let resizer = false;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizer);
        resizer = setTimeout(() => location.reload(), 250);
      });
    
      if (window.matchMedia('(min-width: 1024px)').matches) {
        gsap.registerPlugin(ScrollTrigger);
        
      // if (id == 35) {
        window.locomotive = new LocomotiveScroll( {
          el: document.querySelector( '.scroll-container' ),
          smooth: true,
          multiplier: .5,
          tablet: {
            smooth: false,
          },
          smartphone: {
            smooth: false,
          }
        });

        locomotive.on('scroll', checkFaders);
        
        ScrollTrigger.defaults({
          scroller: '.scroll-container',
          markers: false,
        });

        // Update scroll position
        locomotive.on( 'scroll', ( instance ) => {
          ScrollTrigger.update();
          // document.documentElement.setAttribute( 'data-scrolling', instance.direction );
        });

        // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
        ScrollTrigger.scrollerProxy(".scroll-container", {
          scrollTop(value) {
            return arguments.length ? locomotive.scrollTo(value, 0, 0) : locomotive.scroll.instance.scroll.y;
          }, // we don't have to define a scrollLeft because we're only scrolling vertically.
          getBoundingClientRect() {
            return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
          },
          // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
          pinType: document.querySelector(".scroll-container").style.transform ? "transform" : "fixed"
        });
      // }

        const length = 
          this.$refs.inner.clientWidth + 
          this.$refs.inner.offsetLeft - 
          this.$refs.outer.offsetLeft - 
          this.$refs.outer.clientWidth;

        if (length > window.innerWidth) {
          const pinner = gsap.timeline({
            scrollTrigger: {
              trigger: this.$refs.outer,
              start: "center center",
              end: `+=${length}`,
              pin: this.$el,
              scrub: true
            }
          }).to(this.$refs.inner, {ease: 'none', x: -length});

          // const scroll = gsap.timeline({
          //   scrollTrigger: {
          //     trigger: this.$refs.outer,
          //     start: "top bottom",
          //     end: `+=${length + window.innerHeight}`,
          //     scrub: true,
          //   }
          // }).to(this.$refs.inner, {ease: 'none', x: -length});
        } else {
          const scroll = gsap.timeline({
            scrollTrigger: {
              trigger: this.$refs.outer,
              start: "top 75%",
            }
          }).to(this.$refs.inner, {x: -length, duration: 1});
        }
      
      // if (id == 35) {
        // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
        ScrollTrigger.addEventListener("refresh", () => locomotive.update());

        // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
        ScrollTrigger.refresh();
      }
      // }
    }
  }
});